import { Box } from "@mui/material";

import Logo from "../../assets/images/payment-link/logo.png";

const PaymentLinkNavBar = () => {
  return (
    <Box
      component="nav"
      sx={{
        width: "100%",
        padding: "20px 80px",
        background: "#FFF",
      }}
    >
      <img src={Logo} style={{ width: "94.6px", height: "34px" }} />
    </Box>
  );
};

export default PaymentLinkNavBar;
